import { merge } from '../helper';

import isEmptyObject from '../general/isEmpty/isEmptyObject';

import * as exElement from './element';
import * as exHeader from './header';

// ----------------------------------------------------------------------------

function create(config: Record<string, any> = {}): Record<string, any> {
    // Default Config
    const defConfig: Record<string, any> = {};

    // Merge
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    //
    const elements: Record<string, any> = {};

    // Create element (group)
    const elGroup = exElement.create({
        merge: defConfig,
        class: {
            new: 'group',
        },
    });
    elements.element = elGroup;

    // ------------------------------------------------------------------------

    // Settings
    settings(elements, defConfig);

    // ------------------------------------------------------------------------

    // Return
    return elements;
}

function settings(elements: Record<string, any>, config: Record<string, any> = {}): void {
    // If using header
    if (!isEmptyObject(config.header) || config.header === true) {
        // Create element (header)
        const header = exHeader.create({
            merge: config.header,
            class: {
                new: 'group-header',
            },
        });
        elements.element.appendChild(header.element);
        elements.header = header;
    }

    // If using body
    if (!isEmptyObject(config.body) || config.body === true) {
        // Create element (body)
        const elBody = exElement.create({
            merge: config.body,
            class: {
                new: 'group-body',
            },
        });
        elements.element.appendChild(elBody);
        elements.body = elBody;
    }

    // If using footer
    if (!isEmptyObject(config.footer) || config.footer === true) {
        // Create element (footer)
        const elFooter = exElement.create({
            merge: config.footer,
            class: {
                new: 'group-footer',
            },
        });
        elements.element.appendChild(elFooter);
        elements.footer = elFooter;
    }
}

// ----------------------------------------------------------------------------

export { create };
